export const environment = {
    production: false,

    baseUrl: 'https://dev-assets.trask.cz/be',

    oidcApple: { 
        clientId: 'com.trask.jtassets.web',
        redirectUrl: 'https://dev-assets.trask.cz/be/oidc/apple/callback',
    },

    loginApiService: {
        clientId: 'web-app',
        baseUrlOauth2: 'https://dev-assets.trask.cz/be/oauth2',
        redirectUrl: 'https://dev-assets.trask.cz/web-app/callback'
    },

}